module.exports = __webpack_public_path__ + "static/media/jt_favicon.251ce900.ico";